import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import api from '@/constant/END_POINT'

const updateBackofficeApproverCondition = async (
  id: string | number,
  approvalLevelName: string,
  amountMin: number,
  amountMax: number,
) => {
  const response = await httpClientPrivate.post(
    api.backoffice.updateBackofficeApproverCondition(id),
    {
      approvalLevelName,
      amountMin,
      amountMax,
    },
  )

  return response.data
}

const useUpdateBackofficeApproverCondition = () => {
  const mutation = useMutation({
    mutationKey: ['useUpdateBackofficeApproverCondition'],
    mutationFn: async ({
      id,
      approvalLevelName,
      amountMin,
      amountMax,
    }: {
      id: string | number
      approvalLevelName: string
      amountMin: number
      amountMax: number
    }) => updateBackofficeApproverCondition(id, approvalLevelName, amountMin, amountMax),
  })

  return mutation
}

export { useUpdateBackofficeApproverCondition }
